/*
 * @Description:
 * @Author: 姓名
 * @Date: 2024-08-30 16:18:39
 * @LastEditTime: 2024-11-22 16:54:13
 * @LastEditors: caoran
 */
/* eslint-disable */
import fetchHelper from '../utils/fetchHelper'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'

const manualReviewApiHost = __API_SERVER_HOST__

export function getVerifyLimitCount(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/right/limit',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}
export function verifyCountLimitReduce(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/right/limit/reduce',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function checkVerifyAccountStatus(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/truthful/account',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function createBatchVerifyTask(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/truthful/create/batch',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function getVipInfo(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/user/vip/info',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function queryBatchVerifyTask(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/truthful/query/batch',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function cancelBatchVerifyTask(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/truthful/cancel',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function queryVerifyDetail(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/truthful/query/batch/detail',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 支付完成后创建 Web 人工审核预任务。
 * 用户身份、手机号、钉钉 webhook 和通知均由服务端负责，浏览器只提交业务字段。
 */
export function precreatePaidManualReview(data: {
  orderNo: string
  questionDescription: string
  pageSource: string
  photoUrls: string[]
}) {
  return (dispatch, getState) => {
    const config = {
      url: manualReviewApiHost + '/web/truthful/manual_review/precreate',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

export function queryPaidManualReviewPrecreate(data: { pushTaskId: string }) {
  return (dispatch, getState) => {
    const config = {
      url: manualReviewApiHost + '/web/truthful/manual_review/precreate/query',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => result.data)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}
